import { Component, Input, OnInit } from "@angular/core";
import { DateTime, Duration } from "luxon";
import { WidgetsService } from "src/app/shared/services/widgets.service";

@Component({
  selector: 'widget-evaluation-judge',
  templateUrl: './widget-evaluation-judge.component.html',
  styleUrls: ['./widget-evaluation-judge.component.scss']
})
export class WidgetEvaluationJudgeComponent implements OnInit {
  @Input() widgetConfig;
  stageId = null;
  stageName = '';
  neededReviews = 5;
  completedReviews = 0;
  timeLeftToStart = 0;
  timeLeftToStartCalculated: number = 0;
  timeLeftString = 'Days';

  buttonLink = '';
  buttonText = '';

  calculatedArcStyle = ''
  loading = false;

  isDeadlinePassed = false;

  failedToLoad: boolean = false;
  
  constructor(private widgetsService: WidgetsService) { }

  ngOnInit() {
    this.init()
  }

  async init() {
    this.loading = true;
    this.stageId = this.widgetConfig?.widgetSettings?.stageId;
    if (!this.stageId) return;

    try {
      const res: any = await this.widgetsService.getEvaluationJudgeWidgetData(this.stageId).toPromise();
      this.stageName = res.stageName;
      this.neededReviews = res.neededReviews;
      this.completedReviews = res.completedReviews;
      const currentDate = DateTime.fromISO(DateTime.fromJSDate(new Date()).setZone("UTC").toISO());
      // get stage start date (and time)
      // it's important to map the start date coming from RP as UTC zone, otherwise the user's timezone is attached to it
      // as if it was in the user's timezone instead of UTC
      const stageStartDate = DateTime.fromISO(res.stageStartDate, {zone: 'UTC'});
      this.isDeadlinePassed = res.stageEndDate < DateTime.fromJSDate(new Date()).setZone("UTC").toISO();

      this.timeLeftToStart = stageStartDate.diff(currentDate, 'seconds').toObject().seconds;

      if (this.timeLeftToStart > 172800) {
        // more than 2 days remaining
        // calculating days using luxon's duration
        // calculate in milliseconds and then turn them to days and parse the days as integer
        this.timeLeftToStartCalculated = parseInt(Duration.fromMillis(stageStartDate.diff(currentDate, 'milliseconds').toObject().milliseconds).toFormat('d'));
        this.timeLeftString = 'Days';
      } else if (this.timeLeftToStart > 86400) {
        // between 1 and 2 days
        // calculating days using luxon's duration
        // calculate in milliseconds and then turn them to days and parse the days as integer
        this.timeLeftToStartCalculated = parseInt(Duration.fromMillis(stageStartDate.diff(currentDate, 'milliseconds').toObject().milliseconds).toFormat('d'));
        this.timeLeftString = 'Day';
      } else if (this.timeLeftToStart > 3600) {
        // between 1 and 24 hours
        this.timeLeftToStartCalculated = Math.trunc(stageStartDate.diff(currentDate, 'hours').toObject().hours);
        this.timeLeftString = this.timeLeftToStartCalculated === 1 ? `Hour` : `Hours`;
      } else if (this.timeLeftToStart > 0) {
        // less than 1 hour
        this.timeLeftToStartCalculated = Math.trunc(stageStartDate.diff(currentDate, 'minutes').toObject().minutes);
        // fix for less than 1 minute remaining
        if (this.timeLeftToStartCalculated < 1) {
          this.timeLeftToStartCalculated = 1;
        }
        this.timeLeftString = this.timeLeftToStartCalculated === 1 ? `Minute` : `Minutes`;
      } else {
        // stage has started
      }

      if (this.completedReviews === this.neededReviews) {
        this.buttonLink = `/evaluation/${this.stageId}`;
        this.buttonText = 'View';
      } else {
        this.buttonLink = `/evaluation/${this.stageId}`;
        this.buttonText = 'Review';
      }

      const percentage = (this.completedReviews / this.neededReviews) * 100 || 0;
      const color = percentage === 100 ? '#32a752' : '#FFAD34';
      if (percentage) {
        this.calculatedArcStyle = `transform: rotate(${45+(percentage * 1.8)}deg); border-bottom-color: ${color}; border-right-color: ${color};`;
      }
      this.loading = false;
      this.failedToLoad = false;
    } catch (error) {
      this.loading = false;
      this.failedToLoad = true;
      console.log(error);
    }
  }

  reloadWidget() {
    this.init();
  }
}